export const api = {
  host: 'https://woodenstreet.api.flowsmart.ai'
};
